import {Body1, Spinner} from "@fluentui/react-components";
import {RouterProps} from "../../RouterProps";
import {useParams} from "react-router-dom";
import {useStatePair} from "react-type-extension";
import {ContentQueryValueObject} from "../../../data/value-object/content/ContentQueryValueObject";
import {useEffect} from "react";
import {ContentQueryIO} from "../../../io/ContentIO";
import {ContentQueryDescription} from "../../../data/description/content/ContentQueryDescription";
import {ContentQueryDomain} from "../../../data/domain/content/ContentQueryDomain";
import {ContentQueryDescriptor} from "../../../data/descriptor/content/ContentQueryDescriptor";
import {DetailDefaultPanel, DetailDefaultTab} from "../../DetailViews";

export default function Detail(props: RouterProps) {
    const params = useParams<{ contentQueryId: string }>()
    const item = useStatePair<ContentQueryValueObject | undefined>(undefined)

    useEffect(() => {
        if (item.value === undefined && params.contentQueryId !== undefined) {
            ContentQueryIO
                .getById(BigInt(params.contentQueryId))
                .then(item.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
        }
    }, []);

    return <>
        {item.value === undefined && <Spinner />}
        {item.value !== undefined && <Page {...props} item={item.value} /> }
    </>
}

type PageProps = RouterProps & {
    item: ContentQueryValueObject
}

function Page(props: PageProps) {
    return <>
        <div className={props.styles.row16}>
            <DetailDefaultTab {...props} />
            <DetailDefaultPanel
                {...props}
                client={ContentQueryIO}
                description={ContentQueryDescription}
                properties={props => <PropertyBody {...props} />}/>
        </div>
    </>
}

type PropertyBodyProps = PageProps & {
    itemKey: keyof ContentQueryDomain
}

function PropertyBody(props: PropertyBodyProps) {
    switch (props.itemKey) {
        case "id":
        case "contentType":
        case "body":
        case "createdAt":
        case "concealedAt":
            return <Body1>{ContentQueryDescriptor[props.itemKey](props.item)}</Body1>
        case "userId":
            return <a href={`/users/${props.item.userId}`}><Body1>{ContentQueryDescriptor[props.itemKey](props.item)}</Body1></a>
    }
}